var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7419 0.21312C4.90936 0.21312 0.854492 7.49181 0.854492 7.49181C0.854492 7.49181 4.90936 14.7705 11.7419 14.7705C18.4391 14.7705 22.5021 7.49181 22.5021 7.49181C22.5021 7.49181 18.4391 0.21312 11.7419 0.21312ZM11.6788 2.39671C14.3171 2.39671 16.4142 4.65311 16.4142 7.4918C16.4142 10.3305 14.3171 12.5869 11.6788 12.5869C9.04047 12.5869 6.94336 10.3305 6.94336 7.4918C6.94336 4.65311 9.04047 2.39671 11.6788 2.39671ZM8.97266 7.49178C8.97266 5.89047 10.1903 4.5803 11.6786 4.5803L11.6779 4.57957C12.0838 4.57957 12.418 4.66182 12.7563 4.8074C12.4857 5.02576 12.3544 5.30817 12.3544 5.67211C12.3544 6.2544 12.828 6.76391 13.3692 6.76391C13.7074 6.76391 13.9699 6.6227 14.1728 6.33155C14.3081 6.69549 14.3846 7.05506 14.3846 7.49178C14.3846 9.09309 13.1669 10.4033 11.6786 10.4033C10.1903 10.4033 8.97266 9.09309 8.97266 7.49178Z",
    fill: "#5E7079"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.c535b80c.svg";
export { ForwardRef as ReactComponent };